import MemberSwitch from '@Pages/Detail/components/member_switch/view';
import PriceVersionNote from '@Pages/Detail/components/price_version_note/view';
import { PriceTableProps, MemberShipProps } from '@Pages/Detail/props';
import React from 'react';
import s from './style.module.css';
import { priceFormat } from '@Util/util';

const SellingPriceTable = (props: MemberShipProps) => {
    const [membership, setMemberShip] = React.useState(props.memberships[0]);

    const filteredMembership = props.memberships.filter((v) => !v.isInitialOffering);
    return (
        <div>
            <MemberSwitch
                onChange={(v) => setMemberShip(v)}
                memberships={filteredMembership}
                currentMembership={membership}
            />
            <PriceTable membership={membership} isJpy={props.isJpy} />
            <PriceVersionNote memberships={[membership]} />
        </div>
    );
};

const PriceTable = (props: PriceTableProps) => {
    const membership = props.membership;
    const priceUnit = props.isJpy ? '万円' : 'THB';
    return (
        <table className={s.price_table}>
            <tbody>
                <tr>
                    <th>
                        買希望最高値<span className={s.price_table_supplement || '-'}>（件数）</span>
                    </th>
                    <td>
                        {membership.isAsk ? <span>ご相談</span> : priceFormat(membership.buyingPrice, priceUnit)}
                        <span className={s.price_table_supplement}>（{membership.numberOfBuyingOffers}件）</span>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default SellingPriceTable;
